import type { SVGProps } from "react"

export default function AppLogoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Nose - filled */}
      <path d="m12.5 17-.5-1-.5 1h1z" fill="currentColor" />
      {/* Skull outline and jaw */}
      <path d="M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z" />
      {/* Eyes - filled circles */}
      <circle cx="15" cy="12" r="1" fill="currentColor" />
      <circle cx="9" cy="12" r="1" fill="currentColor" />
    </svg>
  )
}
